import React from "react";
import Modal from "react-modal";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { icons } from "../../assets/icons";
import { CustomPdfViewer } from "../../components/CustomPdfViewer/CustomPdfViewer";
import { pdfjs } from "react-pdf";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   'pdfjs-dist/build/pdf.worker.min.js',
//   import.meta.url,
// ).toString();
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

let imageFormats = ["png", "jpeg", "jpg"];
let previewPossibleFormats = ["png", "jpeg", "jpg", "pdf"];

export const PreviewDocModal = ({ isModalVisible, setIsModalVisible }) => {
  const { apiCall: attachmentSignedUrl } = useApi();
  const modalData = isModalVisible;
  var file = new File([modalData?.file], modalData?.filename);

  const { isOpen = false } = modalData;

  const onRequestClose = () => {
    setIsModalVisible({ ...isModalVisible, isOpen: false });
  };

  const { filename = " " } = modalData;
  const lastIndex = filename.split(".").length;
  const format = filename.split(".")[lastIndex - 1];
  const isFileNotImage = imageFormats?.includes(format);
  const previewPossible = previewPossibleFormats?.includes(format);

  const getSignedUrl = () => {
    attachmentSignedUrl({
      url: apiUrls.dmsService.getSignedUrl + "/" + modalData?.file_id,
      method: "get",
      onSuccess: (apiData) => {
        window.open(apiData, "_blank");
      },
    });
  };

  return (
    <div className="flex justify-center items-center w-full">
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        style={{
          content: {
            display: "flex",
            justifyContent: "center",
            borderRadius: "1rem",
            background: "#fff",
            padding: "2rem",
          },
          overlay: {
            background: "#000000 0% 0% no-repeat padding-box",
            zIndex: 9,
          },
        }}
      >
        {previewPossible ? (
          <div>
            {!isFileNotImage ? (
              <div className="flex justify-center w-full h-full">
                <CustomPdfViewer file={modalData.file} />
                <div
                  className="text-3xl cursor-pointer text-red"
                  style={{ alignItems: "flex-start" }}
                  onClick={() =>
                    setIsModalVisible({ ...isModalVisible, isOpen: false })
                  }
                >
                  [x]
                </div>
                <button className="open-in-new-tab" onClick={getSignedUrl}>
                  Open in a new tab
                </button>
              </div>
            ) : (
              <div className="flex justify-between w-full grow">
                <div className="flex border-[1px] border-[#000] justify-center relative w-[100%]">
                  <TransformWrapper
                    initialPositionX={0}
                    initialPositionY={0}
                    limitToBounds
                  >
                    {({ zoomIn, zoomOut }) => (
                      <React.Fragment>
                        <div className="flex items-center absolute top-[0.8rem] left-[1rem] z-10 gap-x-3">
                          <img
                            src={icons.zoomInIcon}
                            onClick={() => {
                              zoomIn();
                            }}
                            alt="zoom icon"
                            className="cursor-pointer"
                          />
                          <img
                            src={icons.zoomOutIcon}
                            onClick={() => {
                              zoomOut();
                            }}
                            alt="zoom icon"
                            className="cursor-pointer"
                          />
                        </div>
                        <TransformComponent
                          contentClass="h-[100%] w-[100%]"
                          wrapperClass="h-[100%] w-[100%]"
                        >
                          {modalData?.file && (
                            <img
                              style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "contain",
                                // objectFit: "scale-down",
                              }}
                              src={URL.createObjectURL(file)}
                              alt="attachment"
                            />
                          )}
                        </TransformComponent>
                      </React.Fragment>
                    )}
                  </TransformWrapper>
                </div>
                <div
                  className="text-3xl cursor-pointer text-red ml-4"
                  onClick={() =>
                    setIsModalVisible({ ...isModalVisible, isOpen: false })
                  }
                >
                  [x]
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="flex border-[1px] border-[#000] justify-center items-center relative grow">
            <p className="text-lg">
              Preview not available. Please download the File to Review
            </p>
            <div
              className="text-3xl cursor-pointer text-red absolute top-1.5 right-1.5"
              style={{ alignItems: "flex-start" }}
              onClick={() =>
                setIsModalVisible({ ...isModalVisible, isOpen: false })
              }
            >
              [x]
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default PreviewDocModal;
